/* ============================================================
   Bone Appetito — theme.js
   Connects the cinematic UI to Shopify's real cart + checkout.
   The cart drawer, add-to-cart, box builder and barrel config
   all post to Shopify's /cart AJAX endpoints, so inventory,
   pricing and checkout are handled by Shopify itself.
   ============================================================ */

/* ---------- money formatting ---------- */
function money(cents){
  return '$' + (cents/100).toFixed(2);
}

/* ---------- toast ---------- */
function toast(m){
  const t=document.getElementById('toast');
  if(!t)return;
  t.textContent=m;t.classList.add('show');
  clearTimeout(window._t);window._t=setTimeout(()=>t.classList.remove('show'),2200);
}

/* ---------- CART: talks to Shopify AJAX API ---------- */
async function fetchCart(){
  const r=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
  return r.json();
}
async function addToCart(variantId, quantity, properties){
  const body={items:[{id:variantId, quantity:quantity||1}]};
  if(properties)body.items[0].properties=properties;
  const r=await fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(body)
  });
  if(!r.ok){const e=await r.json().catch(()=>({}));toast(e.description||'Could not add to cart');return null;}
  const data=await r.json();
  await refreshCart();
  return data;
}
async function changeCartLine(line, quantity){
  await fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({line:line, quantity:quantity})
  });
  await refreshCart();
}
async function refreshCart(){
  const cart=await fetchCart();
  const dot=document.getElementById('cartDot');
  if(dot)dot.textContent=cart.item_count;
  renderDrawer(cart);
  return cart;
}
function renderDrawer(cart){
  const db=document.getElementById('db'),df=document.getElementById('df');
  if(!db||!df)return;
  if(!cart.items.length){
    db.innerHTML='<div class="d-empty"><span class="em">✦</span>Your cart is quiet.<br>Fill it with something worthy.</div>';
    df.innerHTML='';return;
  }
  db.innerHTML=cart.items.map((it,i)=>{
    const meta=(it.properties&&Object.keys(it.properties).length)
      ? Object.entries(it.properties).filter(([k])=>!k.startsWith('_')).map(([k,v])=>`${v}`).join(' · ') : '';
    const img=it.image
      ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x120$1$2')}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:4px">`
      : (it.product_title||'').slice(0,1);
    return `<div class="ci">
      <div class="ci-ic">${img}</div>
      <div class="ci-m"><b>${it.product_title}</b>${meta?`<small>${meta}</small>`:''}
        <div class="ci-q">
          <button onclick="changeCartLine(${i+1},${it.quantity-1})" aria-label="Decrease">−</button>
          <span>${it.quantity}</span>
          <button onclick="changeCartLine(${i+1},${it.quantity+1})" aria-label="Increase">+</button>
        </div>
        <button class="ci-rm" onclick="changeCartLine(${i+1},0)">Remove</button>
      </div>
      <div class="ci-p">${money(it.final_line_price)}</div>
    </div>`;
  }).join('');
  const left=Math.max(0,10000-cart.total_price);
  df.innerHTML=`
    <div class="ship">${left>0?`${money(left)} from complimentary shipping`:'✦ Complimentary shipping unlocked'}</div>
    <div class="sub"><span class="t">Subtotal</span><span class="v">${money(cart.total_price)}</span></div>
    <button class="btn btn-solid" onclick="goCheckout()">Proceed to Checkout</button>`;
}
function goCheckout(){ window.location.href='/checkout'; }

function openCart(){
  refreshCart();
  document.getElementById('drawer').classList.add('show');
  document.getElementById('ov').classList.add('show');
}
function closeCart(){
  document.getElementById('drawer').classList.remove('show');
  document.getElementById('ov').classList.remove('show');
}

/* product add — used by floating cards. Reads variant id from the button. */
async function cardAdd(btn){
  const vid=btn.getAttribute('data-variant');
  if(!vid){toast('This product needs a variant');return;}
  await addToCart(vid,1);
  toast('Added to cart ✦');
  openCart();
}

/* ---------- DRIFTING DUST ---------- */
(function(){
  const d=document.getElementById('dust');if(!d)return;
  let s='';for(let i=0;i<26;i++){const x=Math.random()*100,dur=10+Math.random()*16,delay=-Math.random()*20,sz=1+Math.random()*2.5;
    s+=`<i style="left:${x}%;width:${sz}px;height:${sz}px;animation-duration:${dur}s;animation-delay:${delay}s"></i>`;}
  d.innerHTML=s;
})();

/* ---------- MANIFESTO word reveal ---------- */
(function(){
  const el=document.getElementById('manifesto');if(!el)return;
  const txt=el.textContent;
  el.innerHTML=txt.split(' ').map(w=>`<span class="word">${w}</span>`).join(' ');
})();
function litManifesto(){
  const words=document.querySelectorAll('#manifesto .word');if(!words.length)return;
  const vh=window.innerHeight;
  words.forEach(w=>{const r=w.getBoundingClientRect();if(r.top<vh*0.78&&r.bottom>vh*0.12)w.classList.add('lit');});
}

/* ---------- FLOATING CARD 3D TILT ---------- */
function initTilt(){
  document.querySelectorAll('[data-tilt]').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      const r=card.getBoundingClientRect();
      const px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;
      card.style.transform=`translateY(-8px) rotateX(${-py*7}deg) rotateY(${px*9}deg)`;
    });
    card.addEventListener('mouseleave',()=>{card.style.transform='';});
  });
}

/* ---------- BUILD YOUR BOX ----------
   Reads selectable treats from data attributes rendered by Liquid.
   Each chosen treat is recorded; the finished box adds a single
   "Treat Box" product to Shopify with the contents as line-item
   properties (so you see exactly what's inside each order).
------------------------------------------------------------------ */
let box=[];
function boxAdd(btn){
  if(btn.dataset.available==='false'){toast('That one is sold out');return;}
  box.push({variant:btn.dataset.variant, title:btn.dataset.title, price:parseInt(btn.dataset.price,10), emoji:btn.dataset.emoji||'•', img:btn.dataset.img||''});
  renderBox();
}
function boxRemove(idx){box.splice(idx,1);renderBox();}
function boxDiscount(n){if(n>=6)return .15;if(n>=3)return .10;return 0;}
function renderBox(){
  const vis=document.getElementById('boxVis'),fill=document.getElementById('boxFill'),empty=document.getElementById('boxEmpty');
  if(!vis)return;
  empty.style.display=box.length?'none':'grid';
  vis.classList.toggle('open',box.length>0);
  fill.innerHTML=box.map(b=>b.img?`<img class="chimg" src="${b.img}" alt="">`:`<span class="ch">${b.emoji}</span>`).join('');
  document.getElementById('bbList').innerHTML=box.map((b,i)=>
    `<div class="bb-line">${b.img?`<img class="chimg" style="width:22px;height:22px" src="${b.img}" alt="">`:`<span class="em">${b.emoji}</span>`}<span class="nm">${b.title}</span><span>${money(b.price)}</span><span class="rm" onclick="boxRemove(${i})">✕</span></div>`).join('');
  const raw=box.reduce((s,b)=>s+b.price,0),disc=boxDiscount(box.length),net=Math.round(raw*(1-disc));
  document.getElementById('boxTotal').textContent=money(net)+(disc?`  (−${disc*100}%)`:'');
  const n=box.length;let label,pct;
  if(n<3){label=`Add ${3-n} to save 10%`;pct=n/3*100;}
  else if(n<6){label=`✦ 10% on — add ${6-n} for 15%`;pct=n/6*100;}
  else{label='✦ Maximum 15% saving unlocked';pct=100;}
  document.getElementById('tierLabel').textContent=label;
  document.getElementById('tierBar').style.width=Math.min(100,pct)+'%';
}
async function addBox(btn){
  if(!box.length){toast('Add a few treats first');return;}
  // Group identical treats into quantities, add each as a REAL line item
  // so the customer is charged for exactly what's in the box.
  const byVariant={};
  box.forEach(b=>{
    if(!b.variant)return;
    byVariant[b.variant]=(byVariant[b.variant]||0)+1;
  });
  const ids=Object.keys(byVariant);
  if(!ids.length){toast('These treats need product variants set up');return;}
  const disc=boxDiscount(box.length);
  const stamp='Box · '+new Date().toLocaleDateString();
  const items=ids.map(id=>({
    id:parseInt(id,10),
    quantity:byVariant[id],
    properties:{'_box':stamp}   // groups the lines visually; underscore hides it at checkout
  }));
  btn.disabled=true;
  const r=await fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:items})
  });
  btn.disabled=false;
  if(!r.ok){const e=await r.json().catch(()=>({}));toast(e.description||'Could not add box');return;}
  await refreshCart();
  box=[];renderBox();
  toast(disc?`Box added — ${disc*100}% saving applies at checkout ✦`:'Box added to cart ✦');
  openCart();
}

/* ---------- BARREL CONFIGURATOR ----------
   Visual blueprint identical to the standalone version, but the
   "Add to Cart" maps the chosen style+size to a real Shopify
   product variant (configured per-section in the theme editor).
------------------------------------------------------------------ */
const SPOTS={
  staves:{t:"Oak Staves",x:"The barrel's original curved timber — wine-stained over years, kept intact for colour and grain."},
  hoops:{t:"Steel Hoops",x:"The galvanised bands stay on as structural rings — cleaned, sealed, rust-treated to last decades."},
  cushion:{t:"Fitted Cushion",x:"A made-to-measure, removable, washable cushion in eucalyptus canvas or ochre duck."},
  base:{t:"Stability Base",x:"Hidden timber feet keep it from rocking and lift it off cold floors for airflow."}
};
const SIZES={S:{n:"Small",dia:"40cm",fits:"≤ 8kg"},M:{n:"Medium",dia:"52cm",fits:"8–22kg"},L:{n:"Large",dia:"64cm",fits:"22kg +"}};
let bStyle='round',bSize='M',BARREL=null;

/* ---- realistic barrel illustrations (shared defs: oak grain, hoops) ---- */
function woodStreaksH(cx,cy,ry,len,seed){
  let g='<g opacity="0.26">';let rnd=seed||1;
  function rng(){rnd=(rnd*9301+49297)%233280;return rnd/233280;}
  for(let i=0;i<22;i++){
    const y=cy-ry+2*ry*rng();const sway=(rng()-0.5)*12;
    const col=rng()>0.5?'#2a1408':'#9c5a30';const w=0.6+rng()*1.2;
    const x1=cx-len/2, x2=cx+len/2;
    g+=`<path d="M${x1} ${y.toFixed(0)} Q${cx} ${(y+sway).toFixed(0)} ${x2} ${y.toFixed(0)}" stroke="${col}" stroke-width="${w.toFixed(1)}" fill="none"/>`;
  }
  return g+'</g>';
}
function woodStreaks(cx,top,bot,r,seed){
  let g='<g opacity="0.28">';
  let rnd=seed||1;
  function rng(){rnd=(rnd*9301+49297)%233280;return rnd/233280;}
  for(let i=0;i<26;i++){
    const x=cx-r+2*r*rng();
    const sway=(rng()-0.5)*10;
    const col=rng()>0.5?'#2a1408':'#9c5a30';
    const w=0.6+rng()*1.2;
    g+=`<path d="M${x.toFixed(0)} ${top} Q${(x+sway).toFixed(0)} ${((top+bot)/2).toFixed(0)} ${x.toFixed(0)} ${bot}" stroke="${col}" stroke-width="${w.toFixed(1)}" fill="none"/>`;
  }
  return g+'</g>';
}
/* ---- realistic barrel illustrations with wood grain, shadows, metal sheen ---- */
function barrelDefs(){return `<defs>
  <linearGradient id="oak" x1="0" y1="0" x2="1" y2="0">
    <stop offset="0" stop-color="#1f0f06"/><stop offset="0.16" stop-color="#43230f"/>
    <stop offset="0.36" stop-color="#6b3a1c"/><stop offset="0.5" stop-color="#7d4624"/>
    <stop offset="0.64" stop-color="#653619"/><stop offset="0.84" stop-color="#3c2010"/>
    <stop offset="1" stop-color="#190c05"/></linearGradient>
  <linearGradient id="oakband" x1="0" y1="0" x2="1" y2="0">
    <stop offset="0" stop-color="#3a1d0e"/><stop offset="0.5" stop-color="#7a4022"/>
    <stop offset="1" stop-color="#301709"/></linearGradient>
  <radialGradient id="wineIn" cx="0.5" cy="0.38" r="0.75">
    <stop offset="0" stop-color="#854438"/><stop offset="0.55" stop-color="#5c2a26"/>
    <stop offset="1" stop-color="#34161488"/></radialGradient>
  <linearGradient id="steel" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0" stop-color="#62656a"/><stop offset="0.3" stop-color="#3a3d42"/>
    <stop offset="0.5" stop-color="#54585e"/><stop offset="0.7" stop-color="#2a2d31"/>
    <stop offset="1" stop-color="#171a1d"/></linearGradient>
  <radialGradient id="cush" cx="0.4" cy="0.32" r="0.85">
    <stop offset="0" stop-color="#c2c8b2"/><stop offset="0.7" stop-color="#9aa087"/>
    <stop offset="1" stop-color="#787e66"/></radialGradient>
  <!-- wood grain texture -->
  <filter id="grain" x="-10%" y="-10%" width="120%" height="120%">
    <feTurbulence type="fractalNoise" baseFrequency="0.012 0.14" numOctaves="4" seed="7" result="n"/>
    <feColorMatrix in="n" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.55 0" result="g"/>
    <feComposite in="g" in2="SourceGraphic" operator="in" result="grainMask"/>
    <feMerge><feMergeNode in="SourceGraphic"/><feMergeNode in="grainMask"/></feMerge>
  </filter>
  <!-- fine metal brush -->
  <filter id="brush" x="-10%" y="-10%" width="120%" height="120%">
    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.5" numOctaves="2" seed="3" result="n"/>
    <feColorMatrix in="n" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.25 0" result="g"/>
    <feComposite in="g" in2="SourceGraphic" operator="in" result="m"/>
    <feMerge><feMergeNode in="SourceGraphic"/><feMergeNode in="m"/></feMerge>
  </filter>
  <filter id="softsh" x="-30%" y="-30%" width="160%" height="160%">
    <feGaussianBlur in="SourceAlpha" stdDeviation="6"/><feOffset dy="8" result="o"/>
    <feComponentTransfer><feFuncA type="linear" slope="0.5"/></feComponentTransfer>
    <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
  </filter>
</defs>`;}

/* stave shadow overlay between vertical planks */

/* OPEN-TOP TUB — half barrel upright, open top with cushion (Images 3 & 4) */
function bpCradle(s){return `<svg class="bd" viewBox="0 0 480 480">${barrelDefs()}
  <ellipse cx="240" cy="446" rx="150" ry="20" fill="rgba(0,0,0,.4)"/>
  <g filter="url(#softsh)">
    <path d="M98 158 Q86 320 126 420 Q240 452 354 420 Q394 320 382 158 Q240 132 98 158 Z" fill="#5c3318"/>
    <path d="M98 158 Q86 320 126 420 Q240 452 354 420 Q394 320 382 158 Q240 132 98 158 Z" fill="url(#oak)" opacity="0.92"/>
  </g>
  <path d="M98 158 Q86 320 126 420 Q240 452 354 420 Q394 320 382 158" fill="none" stroke="#241307" stroke-width="2" opacity=".6"/>
  ${woodStreaks(240,168,418,140,11)}
  ${staveCurved(240,168,418,142,5,'M%X1 %T Q%X2 320 %X3 %B')}
  <!-- side shading -->
  <path d="M98 158 Q86 320 126 420 L150 414 Q116 320 128 162 Z" fill="#1d0f06" opacity=".4"/>
  <path d="M382 158 Q394 320 354 420 L330 414 Q366 320 352 162 Z" fill="#1d0f06" opacity=".4"/>
  <!-- inner wine rim + cushion -->
  <ellipse cx="240" cy="158" rx="142" ry="38" fill="url(#wineIn)"/>
  <ellipse cx="240" cy="158" rx="142" ry="38" fill="none" stroke="#1c0d0a" stroke-width="4"/>
  <ellipse cx="240" cy="150" rx="142" ry="34" fill="none" stroke="#a9683a" stroke-width="3" opacity=".7"/>
  <ellipse cx="240" cy="166" rx="118" ry="29" fill="url(#cush)" stroke="#646a52" stroke-width="1.5"/>
  <ellipse cx="240" cy="162" rx="118" ry="29" fill="none" stroke="#fff" stroke-opacity=".18" stroke-width="1"/>
  <!-- hoops -->
  ${hoop(240,250,138,22)}
  ${hoop(240,366,128,22)}
  ${spot('cushion',240,166)}${spot('staves',150,300)}${spot('hoops',352,258)}${spot('base',240,428)}
</svg>`;}

/* SIDE DEN — full barrel on its side, round opening (Images 1 & 2) */
function bpDen(s){return `<svg class="bd" viewBox="0 0 480 480">${barrelDefs()}
  <ellipse cx="240" cy="436" rx="186" ry="22" fill="rgba(0,0,0,.4)"/>
  <g filter="url(#softsh)">
    <path d="M64 158 Q54 250 64 342 Q64 384 128 384 L352 384 Q416 384 416 342 Q426 250 416 158 Q416 116 352 116 L128 116 Q64 116 64 158 Z" fill="#5c3318"/>
    <path d="M64 158 Q54 250 64 342 Q64 384 128 384 L352 384 Q416 384 416 342 Q426 250 416 158 Q416 116 352 116 L128 116 Q64 116 64 158 Z" fill="url(#oak)" opacity="0.92"/>
  </g>
  ${woodStreaksH(240,250,86,300,17)}
  <!-- horizontal stave bands -->
  <g stroke="#1c0f07" stroke-width="2.5" opacity=".5" fill="none">
    <path d="M66 186 Q240 198 414 186"/><path d="M62 250 L418 250"/><path d="M66 314 Q240 302 414 314"/></g>
  <g stroke="#c98a52" stroke-width="1" opacity=".4" fill="none"><path d="M66 189 Q240 201 414 189"/><path d="M66 317 Q240 305 414 317"/></g>
  <!-- top/bottom edge shading -->
  <path d="M64 158 Q54 250 64 342 L88 342 Q78 250 88 158 Z" fill="#1d0f06" opacity=".35"/>
  <path d="M416 158 Q426 250 416 342 L392 342 Q402 250 392 158 Z" fill="#1d0f06" opacity=".35"/>
  <!-- opening -->
  <ellipse cx="240" cy="250" rx="120" ry="96" fill="#1c0f0a"/>
  <ellipse cx="240" cy="250" rx="116" ry="92" fill="url(#wineIn)"/>
  <ellipse cx="240" cy="250" rx="116" ry="92" fill="none" stroke="#150a08" stroke-width="5"/>
  <ellipse cx="240" cy="250" rx="116" ry="92" fill="none" stroke="#a9683a" stroke-width="2" opacity=".6"/>
  <!-- inner stave hint -->
  <path d="M150 200 Q140 250 150 300 M200 180 Q194 250 200 320 M280 180 Q286 250 280 320 M330 200 Q340 250 330 300" stroke="#3a1d18" stroke-width="2" fill="none" opacity=".5"/>
  <!-- cushion -->
  <ellipse cx="240" cy="300" rx="98" ry="32" fill="url(#cush)" stroke="#646a52" stroke-width="1.5"/>
  <!-- end hoops (vertical bands near ends) -->
  ${hoopV(96,116,384)}
  ${hoopV(384,116,384)}
  <!-- feet -->
  <rect x="150" y="380" width="28" height="22" rx="3" fill="#3f2412"/><rect x="302" y="380" width="28" height="22" rx="3" fill="#3f2412"/>
  ${spot('cushion',240,300)}${spot('staves',240,186)}${spot('hoops',390,200)}${spot('base',164,390)}
</svg>`;}

/* ROUND DEN — head-on barrel, deep round burrow */
function bpRound(s){return `<svg class="bd" viewBox="0 0 480 480">${barrelDefs()}
  <ellipse cx="240" cy="448" rx="150" ry="20" fill="rgba(0,0,0,.4)"/>
  <g filter="url(#softsh)">
    <path d="M106 104 Q72 245 106 386 Q240 412 374 386 Q408 245 374 104 Q240 78 106 104 Z" fill="#5c3318"/>
    <path d="M106 104 Q72 245 106 386 Q240 412 374 386 Q408 245 374 104 Q240 78 106 104 Z" fill="url(#oak)" opacity="0.92"/>
  </g>
  ${staveCurved(240,92,388,148,5,'M%X1 %T Q%X2 245 %X3 %B')}
  ${woodStreaks(240,96,388,144,23)}
  <path d="M106 104 Q72 245 106 386 L130 380 Q98 245 130 110 Z" fill="#1d0f06" opacity=".4"/>
  <path d="M374 104 Q408 245 374 386 L350 380 Q382 245 350 110 Z" fill="#1d0f06" opacity=".4"/>
  <!-- opening -->
  <ellipse cx="240" cy="245" rx="110" ry="122" fill="#1c0f0a"/>
  <ellipse cx="240" cy="245" rx="106" ry="118" fill="url(#wineIn)"/>
  <ellipse cx="240" cy="245" rx="106" ry="118" fill="none" stroke="#150a08" stroke-width="5"/>
  <ellipse cx="240" cy="245" rx="106" ry="118" fill="none" stroke="#a9683a" stroke-width="2" opacity=".55"/>
  <!-- cushion -->
  <ellipse cx="240" cy="312" rx="92" ry="32" fill="url(#cush)" stroke="#646a52" stroke-width="1.5"/>
  <!-- hoops -->
  ${hoop(240,160,128,20)}
  ${hoop(240,330,128,20)}
  ${spot('staves',150,200)}${spot('hoops',348,168)}${spot('cushion',240,312)}${spot('base',240,392)}
</svg>`;}

/* helper: curved vertical staves following barrel bulge */
function staveCurved(cx,top,bot,r,n,tpl){
  let g='<g opacity="0.62">';
  for(let i=1;i<n;i++){
    const f=i/n;
    const x1=cx-r+(2*r)*f;
    const bulge=(f-0.5)*2; // -1..1
    const x2=cx-(r+18)+(2*(r+18))*f;
    const x3=x1;
    const d=tpl.replace('%X1',x1.toFixed(0)).replace('%X2',x2.toFixed(0)).replace('%X3',x3.toFixed(0)).replace('%T',top).replace('%B',bot);
    g+=`<path d="${d}" stroke="#1c0f07" stroke-width="2.5" fill="none"/>`;
    g+=`<path d="${d}" stroke="#c98a52" stroke-width="1" fill="none" opacity="0.4" transform="translate(3,0)"/>`;
  }
  return g+'</g>';
}
/* helper: elliptical steel hoop band */
function hoop(cx,cy,rx,h){return `<g filter="url(#brush)">
  <path d="M${cx-rx} ${cy} Q${cx} ${cy+28} ${cx+rx} ${cy} L${cx+rx} ${cy+h} Q${cx} ${cy+28+h} ${cx-rx} ${cy+h} Z" fill="url(#steel)"/>
  <path d="M${cx-rx} ${cy+3} Q${cx} ${cy+30} ${cx+rx} ${cy+3}" fill="none" stroke="#b9bdc1" stroke-width="1.2" opacity=".55"/>
  </g>`;}
/* helper: vertical hoop band near barrel ends (side view) */
function hoopV(x,top,bot){return `<g filter="url(#brush)">
  <path d="M${x-9} ${top+6} Q${x-16} ${(top+bot)/2} ${x-9} ${bot-6} L${x+9} ${bot-6} Q${x+16} ${(top+bot)/2} ${x+9} ${top+6} Z" fill="url(#steel)"/>
  <path d="M${x-6} ${top+8} Q${x-12} ${(top+bot)/2} ${x-6} ${bot-8}" fill="none" stroke="#b9bdc1" stroke-width="1.2" opacity=".5"/>
  </g>`;}
function spot(k,x,y){return `<g class="hot" onclick="showSpot('${k}')"><circle class="ring" cx="${x}" cy="${y}" r="7"/><circle class="dot" cx="${x}" cy="${y}" r="9"/><text x="${x}" y="${y+4}">+</text></g>`;}
function drawBarrel(){
  const holder=document.getElementById('barrelHolder');if(!holder)return;
  const s=SIZES[bSize];
  holder.innerHTML=`<div class="barrel-spots">${{cradle:bpCradle,den:bpDen,round:bpRound}[bStyle](s)}</div>`;
}
function showSpot(k){const s=SPOTS[k];document.getElementById('biTitle').textContent=s.t;document.getElementById('biText').textContent=s.x;}
function pickStyle(el){bStyle=el.dataset.style;document.querySelectorAll('.bstyle').forEach(b=>b.classList.remove('active'));el.classList.add('active');drawBarrel();updateBed();}
function pickSize(el){bSize=el.dataset.size;document.querySelectorAll('.bsz').forEach(b=>b.classList.remove('active'));el.classList.add('active');updateBed();}
function updateBed(){
  const priceEl=document.getElementById('bedPrice');
  const btn=document.getElementById('bedAddBtn');
  if(!priceEl||!btn)return;
  if(!BARREL){priceEl.textContent='—';btn.dataset.variant='';btn.disabled=true;return;}
  const variant=BARREL.variants.find(v=>v.style===bStyle && v.size===bSize);
  if(variant){priceEl.textContent=money(variant.price);btn.dataset.variant=variant.id;btn.disabled=false;}
  else{priceEl.textContent='—';btn.dataset.variant='';btn.disabled=true;}
}
async function addBed(){
  const btn=document.getElementById('bedAddBtn');
  const vid=btn.dataset.variant;
  if(!vid){toast('This style and size is not available');return;}
  await addToCart(vid,1,{'Style':document.querySelector('.bstyle.active b').textContent,'Size':SIZES[bSize].n});
  toast('Barrel bed added ✦');
  openCart();
}
function initBarrel(data){
  BARREL=data;
  drawBarrel();updateBed();
}
function bootBarrel(){
  if(!document.getElementById('barrelHolder'))return;
  if(window.BARREL_DATA)BARREL=window.BARREL_DATA;
  drawBarrel();
  updateBed();
}

/* ---------- SCROLL: progress, header, reveal ---------- */
function enableRevealAnim(){
  document.documentElement.classList.add('reveal-ready');
}
function reveal(){
  document.querySelectorAll('.r').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<window.innerHeight*0.92)el.classList.add('in');});
  const bd=document.getElementById('barrelDraw');
  if(bd){const r=bd.getBoundingClientRect();if(r.top<window.innerHeight*0.85)bd.classList.add('in');}
}
function onScroll(){
  const h=document.documentElement;const sc=h.scrollTop/(h.scrollHeight-h.clientHeight||1);
  const sb=document.getElementById('scrollbar');if(sb)sb.style.width=(sc*100)+'%';
  const hdr=document.getElementById('hdr');if(hdr)hdr.classList.toggle('solid',h.scrollTop>60);
  reveal();litManifesto();
}

/* subscribe handled by Shopify customer form; keep helper for inline form */
function subscribeMsg(){toast('Welcome to the table ✦');}

/* nav scroll helper */
function scrollTo2(id){const el=document.getElementById(id);if(el)el.scrollIntoView({behavior:'smooth'});}

window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('load',()=>{enableRevealAnim();initTilt();reveal();litManifesto();refreshCart();bootBarrel();});
document.addEventListener('DOMContentLoaded',()=>{enableRevealAnim();initTilt();reveal();renderBox();bootBarrel();});

/* safety net: never let .r content stay invisible */
setTimeout(function(){
  document.querySelectorAll('.r').forEach(function(el){el.classList.add('in');});
  bootBarrel();
},1500);
